export const cardTemplates = [
  {
    id: "origin",
    title: "Total Origin",
    amtKey: "totalOrigin",
    descKey: "sourceLines",
    suffix: "Source Lines",
    className: "bg-blue-50"
  },
  {
    id: "distributed",
    title: "Total Distributed",
    amtKey: "totalDistributed",
    descKey: "receiverLegs",
    suffix: "Receiver Logs",
    className: "bg-violet-50"
  },
];